import { DEVELLO_API_ORIGIN, fetchWithAuth } from '../utils/asyncReliability';
import { supabase } from '../supabase';
import { clearSignupPlanIntent, readSignupPlanIntent } from '../utils/signupPlanIntent';
import { startProCheckout } from './billingClient';

/**
 * Ensure profile exists after auth and decide next onboarding step.
 */
export async function ensureProfileAndResolveOnboarding() {
  const signupPlanIntent = readSignupPlanIntent();
  const res = await fetchWithAuth(`${DEVELLO_API_ORIGIN}/api/onboarding/ensure-profile`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ signupPlanIntent }),
    name: 'onboarding:ensureProfile',
    timeoutMs: 45000,
    retries: 1,
    supabaseClient: supabase,
    requireAuth: true,
    retryAuth: true,
  });

  if (!res.ok) {
    const err = new Error(res.userMessage || 'Could not initialize profile');
    /** @type {{ code?: string; userFacing?: string }} */ (err).code = 'PROFILE_CREATION_FAILED';
    /** @type {{ code?: string; userFacing?: string }} */ (err).userFacing =
      res.userMessage || 'Could not initialize your account.';
    throw err;
  }

  return /** @type {{ shouldStartCheckout?: boolean; profile?: unknown }} */ (res.data || {});
}

/**
 * @param {{ allowCheckout?: boolean; includeSignupPlanIntent?: boolean }} [opts]
 */
export async function runPostAuthOnboarding(opts = {}) {
  const allowCheckout = opts.allowCheckout !== false;
  const includeSignupPlanIntent = opts.includeSignupPlanIntent !== false;
  const signupPlanIntent = includeSignupPlanIntent ? readSignupPlanIntent() : null;
  const res = await fetchWithAuth(`${DEVELLO_API_ORIGIN}/api/onboarding/ensure-profile`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ signupPlanIntent }),
    name: 'onboarding:ensureProfile',
    timeoutMs: 45000,
    retries: 1,
    supabaseClient: supabase,
    requireAuth: true,
    retryAuth: true,
  });

  if (!res.ok) {
    const err = new Error(res.userMessage || 'Could not initialize profile');
    /** @type {{ code?: string; userFacing?: string }} */ (err).code = 'PROFILE_CREATION_FAILED';
    /** @type {{ code?: string; userFacing?: string }} */ (err).userFacing =
      res.userMessage || 'Could not initialize your account.';
    throw err;
  }

  const decision = /** @type {{ shouldStartCheckout?: boolean; profile?: unknown }} */ (res.data || {});
  if (allowCheckout && decision?.shouldStartCheckout) {
    try {
      await startProCheckout();
    } catch (error) {
      const e = new Error('Could not start checkout');
      /** @type {{ code?: string; userFacing?: string }} */ (e).code = 'CHECKOUT_START_FAILED';
      /** @type {{ code?: string; userFacing?: string }} */ (e).userFacing =
        'We could not open checkout. Please try again.';
      throw error || e;
    }
    return 'checkout_redirected';
  }
  clearSignupPlanIntent();
  return 'dashboard';
}
